import { Box, Slider } from '@mui/material'
import { SettingsSliderEdgeIcon } from '@/components/Settings/SettingsSliderEdgeIcon'
import styles from '@/components/Settings/SettingsSliderControl.module.scss'

/**
 * @param {{
 *   value: number, onChange: (value: number) => void, min?: number, max?: number, step?: number,
 *   marks?: Array<{ value: number, label?: string }>, 'aria-label': string,
 *   StartIcon?: import('react').ComponentType, EndIcon?: import('react').ComponentType,
 * }} props
 */
export default function SettingsSliderControl({ value, onChange, min = 0, max = 100, step = 1, marks, 'aria-label': ariaLabel, StartIcon, EndIcon }) {
  return (
    <Box className={styles.root}>
      <SettingsSliderEdgeIcon Icon={StartIcon} />
      <Slider value={value} onChange={(_, next) => onChange(typeof next === 'number' ? next : next[0])} min={min} max={max} step={step} marks={marks} aria-label={ariaLabel} className={styles.slider} />
      <SettingsSliderEdgeIcon Icon={EndIcon} />
    </Box>
  )
}
